import { useRouter } from "next/router";
import LinkComponent from "@Components/Link";
import Icon from "@Components/ui/icon";
import { KIOSK_VIEW_MODE_QUERY } from "@Constants/url";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";

import classes from "./RecipesDetail.module.scss";

export const BackToRecipesButton = ({}) => {
  const {
    query: { viewMode },
  } = useRouter();
  const { languageCode } = useAppSelector(localeSelector);
  const backLink = `/${languageCode}/blogs/recipes/${
    viewMode === KIOSK_VIEW_MODE_QUERY
      ? `?viewMode=${KIOSK_VIEW_MODE_QUERY}`
      : ""
  }`;

  return (
    <LinkComponent href={backLink}>
      <button className={classes.backButton}>
        <Icon iconName="arrow-left" className={classes.arrowLeftIcon} />
        Back To Recipes
      </button>
    </LinkComponent>
  );
};
